import AppEntry from './app/ui/AppEntry';

function App() {
  return (
    <AppEntry />
  );
}

export default App;